// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3142":"0ac7fef8","6614":"c9dc8ab3"}[chunkId] + ".chunk.css";
};